<div class="header-container">
  <h2 class="ml-2">User Guide</h2>
</div>
<div class="container">
  <div *ngIf="isPdfPreviewVisible">
    <div class="pdf-preview-container">
      <iframe [src]="pdfUrlData" width="100%" height="560px"></iframe>
    </div>
  </div>
</div>
